import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ArrowRight } from 'common/images/FaIcons';
import { IMPORT_STEPS, IMPORT_STEP_LABELS } from '../../machineCsv.constants';
import {
  Steps, Step, StepNumber, StepArrow
} from './MachineCsv.styled';

function ImportStepIndicator({ current }) {
  const { t } = useTranslation();
  const currentIndex = IMPORT_STEPS.indexOf(current);
  return (
    <Steps aria-label={t('assets.csv.import.stepsLabel', { defaultValue: 'Import steps' })}>
      {IMPORT_STEPS.map((step, index) => (
        <React.Fragment key={step}>
          {index > 0 && <StepArrow aria-hidden="true"><ArrowRight /></StepArrow>}
          <Step
            current={index === currentIndex}
            done={index < currentIndex}
            aria-current={index === currentIndex ? 'step' : undefined}
          >
            <StepNumber current={index === currentIndex} done={index < currentIndex}>{index + 1}</StepNumber>
            {t(`assets.csv.import.steps.${step}`, { defaultValue: IMPORT_STEP_LABELS[step] })}
          </Step>
        </React.Fragment>
      ))}
    </Steps>
  );
}

ImportStepIndicator.propTypes = {
  current: PropTypes.oneOf(IMPORT_STEPS).isRequired
};

export default ImportStepIndicator;
